import Cookies from "js-cookie";

const TokenKey = "token";
const isLocalHost = location.hostname === "localhost";
const hostDomain = isLocalHost ? "" : location.hostname.split(".");
const domain = !isLocalHost ? `.${hostDomain[1]}.${hostDomain[2]}` : "";

export function getToken() {
  return isLocalHost ? Cookies.get(TokenKey) : Cookies.get(TokenKey, { domain: domain });
}

export function getCookieKey(key) {
  return isLocalHost ? Cookies.get(key) : Cookies.get(key, { domain: domain });
}

export function setToken(token) {
  return isLocalHost
    ? Cookies.set(TokenKey, token)
    : Cookies.set(TokenKey, token, { domain: domain });
}

export function setCookieKey(key, params) {
  return isLocalHost ? Cookies.set(key, params) : Cookies.set(key, params, { domain: domain });
}

export function removeToken() {
  Cookies.remove(TokenKey);
  Cookies.remove(TokenKey, { domain: domain });
  // return isLocalHost ? Cookies.remove(TokenKey) : Cookies.remove(TokenKey, { domain: domain });
}

export function removeCookieKey(key) {
  Cookies.remove(key);
  Cookies.remove(key, { domain: domain });
  // return isLocalHost ? Cookies.remove(key) : Cookies.remove(key, { domain: domain });
}
